import type { PivotExpandState } from './types'

// a node is expanded when the layout-wide flag disagrees with its per-node toggle
/** Checks whether a pivot node is expanded under the expand state. */
export const isPivotExpanded = (expandState: PivotExpandState, key: string): boolean =>
  expandState.expandAll !== expandState.toggledKeys.has(key)
